import { getAllTarif } from "App/Component/layout/MasterData/Tarif/helpers";
import { useEffect, useState } from "react";

const defaultLastHead = [
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export default function useHeadTarif({ data }) {
  const [head, setHead] = useState(data);
  const [length, setLength] = useState(1);
  const [dataTarif, setDataTarif] = useState([]);

  useEffect(() => {
    (async () => {
      const tarif = await getAllTarif();

      const dataKelas = [];

      if (tarif) {
        tarif?.map((e) => {
          return dataKelas.push({
            id: `${e.id}`,
            disablePadding: false,
            label: `${e.name}`,
            align: "left",
            minWidth: "200px",
          });
        });
      }

      setLength(tarif?.length);
      const TarifMerge = [...head, ...dataKelas];
      setHead([...TarifMerge, ...defaultLastHead]);
      setDataTarif(tarif);
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    dynamicHead: head,
    lengthTarif: length,
    dataTarif,
  };
}
